import classNames from "classnames";
import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router";

import logo from "../../assets/images/logo-white.png";
import { ADMINISTRATOR, AGENT, DIRECTOR, FINANCE, FINTECH, INTERNAL_ROLES, MANAGER } from "../../utils/Roles";
import userHasAccess from "../../utils/userHasAccess";

const menus = [
  {
    requiredRole: MANAGER,
    to: "/dashboard/admin",
    icon: "icon icon-person",
    title: "admin.title",
  },
  {
    requiredRole: DIRECTOR,
    to: "/dashboard/audit",
    icon: "icon icon-format_list_bulleted",
    title: "audit.title",
  },
  {
    requiredRole: AGENT,
    to: "/dashboard/clients",
    icon: "icon icon-suitcase",
    title: "clients.title",
  },
  {
    exactRole: [FINANCE, ADMINISTRATOR, FINTECH],
    to: "/dashboard/sales-taxes",
    icon: "icon icon-credit",
    title: "salesTaxes.title",
  },
  {
    requiredRole: MANAGER,
    to: "/dashboard/transfer",
    icon: "icon icon-in",
    title: "importExport.title",
  },
  {
    requiredRole: INTERNAL_ROLES,
    to: "/dashboard/synchronizations",
    icon: "icon icon-loop",
    title: "synchronizations.datatable.title",
  },
];

function renderMenu(menu) {
  const hasRoleInList = userHasAccess(menu.requiredRole);
  const isExactRole = !!menu.exactRole
    ? userHasAccess(menu.exactRole, true)
    : false;

  return hasRoleInList || isExactRole;
}

class LeftMenu extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      collapsed: localStorage.getItem("mainMenuIsCollapsed") === "true",
    };

    this.changeCollapsedState = this.changeCollapsedState.bind(this);
  }

  changeCollapsedState() {
    let collapsed = this.state.collapsed;
    this.setState({ collapsed: !collapsed });
    localStorage.setItem("mainMenuIsCollapsed", !collapsed);

    setTimeout(function () {
      const evt = document.createEvent("HTMLEvents");
      evt.initEvent("resize", true, false);
      window.dispatchEvent(evt);
    }, 0);
  }

  render() {
    const { collapsed } = this.state;
    const leftMenuClasses = classNames({
      leftmenu: true,
      open: !collapsed,
    });

    const logoClasses = classNames({
      logo: true,
      open: !collapsed,
    });

    return (
      <nav className={leftMenuClasses}>
        <div className="sidebar_header">
          <span onClick={this.changeCollapsedState} className={logoClasses}>
            <img src={logo} width="150" />
          </span>
        </div>
        <ul className="list-group">
          <li className="list-group-item">
            <Link to="/dashboard/follow-ups" activeClassName="active" className="with-count">
              <span className="icon icon-folder-o" />
              {collapsed ? null : (
                <span className="sidebar-text">
                  <FormattedMessage id="followUps.title" />
                </span>
              )}
              {!!this.props.followUpsCount && (
                <span className="count">{this.props.followUpsCount}</span>
              )}
            </Link>
          </li>

          {menus
            .filter((menu) => renderMenu(menu))
            .map((menu, index) => {
              return (
                <li className="list-group-item" key={index}>
                  <Link to={menu.to} activeClassName="active">
                    <span className={menu.icon} />
                    {collapsed ? null : (
                      <span className="sidebar-text">
                        <FormattedMessage id={menu.title} />
                      </span>
                    )}
                  </Link>
                </li>
              );
            })}
        </ul>
      </nav>
    );
  }
}

LeftMenu.propTypes = {
  followUpsCount: PropTypes.number,
};

LeftMenu.contextTypes = {
  router: React.PropTypes.object,
};

export default LeftMenu;



// WEBPACK FOOTER //
// ./src/components/dashboard/LeftMenu.js